<div *ngIf="(documents$ | async) as documents">
    <h2>Documents <span class="!font-light !text-gray-400">({{documents?.length}})</span></h2>

    <div class="p-2 file-summary mb-2"
         *ngFor="let document of latest3Documents"
         (click)="viewDocument(document)"
         [class.file-clickable] = "document.scanStatus === 'CLEAN'"
         [class.text-gray-400] = "document.scanStatus !== 'CLEAN'"
    >
        <mat-icon>description</mat-icon>
        <div class="file-name">{{document.filename}}</div>
        <mat-spinner *ngIf="!document.scanStatus || document.scanStatus === 'PENDING'"
            [diameter]="20" matTooltip="Scan in progress... This may take a few minutes.">
        </mat-spinner>
        <mat-icon *ngIf="document.scanStatus === 'CLEAN'"
                class="material-symbols-outlined green-check"
                fontSet="material-symbols-outlined"
                matTooltip="Scan successfully completed"
            >
            done
        </mat-icon>
        <mat-icon *ngIf="document.scanStatus === 'INFECTED'"
                class="material-symbols-outlined red-close"
                fontSet="material-symbols-outlined"
                matTooltip="Document scan failed. Try uploading a new file."
            >
            close
        </mat-icon>
    </div>

    <div *ngIf="documents?.length" class="mt-2">
        <button
            mat-button
            [color]="'primary'"
            (click)="viewAllDocuments()"
        >
            View All
        </button>
        <!--        <button-->
        <!--            mat-button-->
        <!--            [color]="'primary'">-->
        <!--            Add Document-->
        <!--        </button>-->
    </div>
</div>

